module.exports = __webpack_public_path__ + "static/img/door_head_photo.7dacb2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/door_head_photo.png
// module id = 1392
// module chunks = 1